"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputTime = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Select = require("../../../elements/select/select/Select");
var _usePrevious = require("../../../hooks/usePrevious/usePrevious");
var _react = _interopRequireWildcard(require("react"));
var _reactTimePicker = _interopRequireDefault(require("react-time-picker"));
var _inputTimeModule = _interopRequireDefault(require("./input-time.module.scss"));
var timeOptions = [{
  label: 'AM',
  value: 'AM'
}, {
  label: 'PM',
  value: 'PM'
}];
var InputTime = function InputTime(_ref) {
  var _classNames;
  var value = _ref.value,
    id = _ref.id,
    name = _ref.name,
    onChange = _ref.onChange,
    small = _ref.small,
    inline = _ref.inline,
    error = _ref.error,
    dataTestId = _ref['data-testid'];
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var _useState3 = (0, _react.useState)(new Date().getHours() > 12 ? 'PM' : 'AM'),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    timeUnit = _useState4[0],
    setTimeUnit = _useState4[1];
  var convertInto24HourFormat = (0, _react.useCallback)(function (value) {
    var valueArray = value.split(':');
    var hours = valueArray[0];
    var hoursInNumber = parseInt(hours);
    if (timeUnit === 'PM' && hoursInNumber < 12) {
      hoursInNumber = hoursInNumber + 12;
    } else if (timeUnit === 'AM' && hoursInNumber >= 12) {
      hoursInNumber = hoursInNumber - 12;
    }
    hours = hoursInNumber.toString();
    if (hoursInNumber < 10) {
      hours = '0' + hoursInNumber;
    }
    valueArray.splice(0, 1, hours);
    value = valueArray.join(':');
    return value;
  }, [timeUnit]);
  var onTimeUnitChange = (0, _react.useCallback)(function (_ref2) {
    var currentTarget = _ref2.currentTarget;
    setTimeUnit(currentTarget.value);
  }, [setTimeUnit]);
  var previousUnit = (0, _usePrevious.usePrevious)(timeUnit);
  (0, _react.useEffect)(function () {
    if (value && previousUnit !== timeUnit) {
      var valueIn24Hour = convertInto24HourFormat(value);
      onChange(valueIn24Hour);
    }
  }, [timeUnit, value, onChange, convertInto24HourFormat, previousUnit]);
  var onTimeChange = (0, _react.useCallback)(function (value) {
    if (value) {
      var valueIn24Hour = convertInto24HourFormat(value);
      onChange(valueIn24Hour);
    }
  }, [onChange, convertInto24HourFormat]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_inputTimeModule.default['input-time'], (_classNames = {}, (0, _defineProperty2.default)(_classNames, _inputTimeModule.default['input-time--inline'], inline), (0, _defineProperty2.default)(_classNames, _inputTimeModule.default['input-time--small'], small), (0, _defineProperty2.default)(_classNames, _inputTimeModule.default['input-time--focused'], isFocused), (0, _defineProperty2.default)(_classNames, _inputTimeModule.default['input-time--error'], error), _classNames))
  }, /*#__PURE__*/_react.default.createElement(_reactTimePicker.default, {
    id: id,
    name: name,
    onChange: onTimeChange,
    small: small,
    value: value,
    clearIcon: null,
    clockIcon: null,
    disableClock: true,
    format: 'h:mm:ss',
    hourPlaceholder: 'HH',
    minutePlaceholder: 'MM',
    secondPlaceholder: 'SS',
    onClockOpen: function onClockOpen() {
      return setIsFocused(true);
    },
    onClockClose: function onClockClose() {
      return setIsFocused(false);
    },
    maxDetail: 'second'
  }), /*#__PURE__*/_react.default.createElement(_Select.Select, {
    className: (0, _classnames.default)(_inputTimeModule.default['input-time__time-unit'], (0, _defineProperty2.default)({}, _inputTimeModule.default['input-time__time-unit--small'], small)),
    id: "".concat(id, "-time"),
    "data-testid": "".concat(dataTestId, "-time"),
    name: "".concat(name, "-time"),
    onChange: onTimeUnitChange,
    options: timeOptions,
    value: timeUnit,
    small: true
  }));
};
exports.InputTime = InputTime;